@if (display) {
  <article [id]="id || 'loader'" class="loading-animation" [ngClass]="!formField ? 'main-loader' : 'form-field'">
    <section>
      <div class="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </section>
    @if ($message | async; as m) {
      <section class="text-wrapper">
        <h4 id="loaderMessageText">{{ m }}</h4>
      </section>
    }
  </article>
}
